import {
    FaReact,
    FaNodeJs,
    FaHtml5,
    FaCss3Alt,
    FaJs,
    FaPython,
    FaGitAlt,
    FaDatabase,
    FaServer,
} from 'react-icons/fa';
import {
    SiNextdotjs,
    SiTypescript,
    SiTailwindcss,
    SiMongodb,
    SiPostgresql,
    SiExpress,
    SiVite,
    SiWebpack,
    SiCss3,
    SiBootstrap,
    SiFastapi,
    SiMysql,
    SiVercel
} from 'react-icons/si';

export const skills = [
    {
        id: 1,
        icon: FaReact,
        title: 'frontend_development',
        displayTitle: 'Frontend Development',
        description: [
            'Building responsive UIs',
            'Modern applications',
            'Component-based architecture'
        ]
    },
    {
        id: 2,
        icon: FaNodeJs,
        title: 'backend_development',
        displayTitle: 'Backend Development',
        description: [
            'RESTful API design',
            'Server-side logic',
            'Database integration'
        ]
    },
    {
        id: 3,
        icon: FaDatabase,
        title: 'database_management',
        displayTitle: 'Database Management',
        description: [
            'SQL & NoSQL databases',
            'Data modeling',
            'Query optimization'
        ]
    },
    {
        id: 4,
        icon: FaServer,
        title: 'fullstack_development',
        displayTitle: 'Full-Stack Development',
        description: [
            'End-to-end solutions',
            'MERN/MEAN stack',
            'Scalable architectures'
        ]
    }
];

export const technologies = {
    languages: [
        { name: 'JavaScript', icon: FaJs, color: '#F7DF1E' },
        { name: 'TypeScript', icon: SiTypescript, color: '#3178C6' },
        { name: 'Python', icon: FaPython, color: '#3776AB' },
        { name: 'HTML5', icon: FaHtml5, color: '#E34F26' },
        { name: 'CSS3', icon: FaCss3Alt, color: '#1572B6' }
    ],
    frontend: [
        { name: 'React', icon: FaReact, color: '#61DAFB' },
        { name: 'Next.js', icon: SiNextdotjs, color: '#000000' },
        { name: 'Tailwind CSS', icon: SiTailwindcss, color: '#06B6D4' },
        { name: 'Vite', icon: SiVite, color: '#646CFF' },
        { name: 'Bootstrap', icon: SiBootstrap, color: '#7952B3' },
        { name: 'CSS', icon: SiCss3, color: '#CC6699' }
    ],
    backend: [
        { name: 'Node.js', icon: FaNodeJs, color: '#339933' },
        { name: 'Express', icon: SiExpress, color: '#000000' },
        { name: 'FastAPI', icon: SiFastapi, color: '#E10098' }
    ],
    databases: [
        { name: 'MongoDB', icon: SiMongodb, color: '#47A248' },
        { name: 'PostgreSQL', icon: SiPostgresql, color: '#4169E1' },
        { name: 'MySQL', icon: SiMysql, color: '#DC382D' }
    ],
    tools: [
        { name: 'Git', icon: FaGitAlt, color: '#F05032' },
        { name: 'Vercel', icon: SiVercel, color: '#2496ED' },
        { name: 'Webpack', icon: SiWebpack, color: '#8DD6F9' },
    ]
};
